export default __webpack_public_path__ + "static/media/Logo.f6ec51ba.svg";